module.exports = __webpack_public_path__ + "img/bgchahua@3x.25abc1b8.png";